import { USER_TYPE_EMPLOYEE } from "@/constants/userTypes";

let routes = [
  {
    path:      '/uc',
    component: () => import('@/layouts/no-header/NoHeader.vue'),
    redirect:  { name: 'uc_b_main' },
    meta:      {
      access: USER_TYPE_EMPLOYEE,
    },
    children:  [
      {
        path:      'b',
        name:      'uc_b_main',
        component: () => import('@/views/uc/b/Main.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.main',

        },
      },
      {
        path:      'b/accounts',
        name:      'uc_b_accounts',
        component: () => import('@/views/uc/b/Accounts.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.main',
        },
      },
      {
        path:      'b/account/:id',
        name:      'uc_b_account',
        component: () => import('@/views/uc/b/Account.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.account',
        },
      },
      {
        path:      'b/account/:id/split',
        name:      'uc_b_account_split',
        component: () => import('@/views/uc/b/AccountSplit.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.account',
        },
      },
      {
        path:      'b/devices',
        name:      'uc_b_devices',
        component: () => import('@/views/uc/b/Devices.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.devices',
        },
      },
      // {
      //   path:      'b/metering/:pageType',
      //   name:      'uc_b_metering',
      //   component: () => import('@/views/uc/b/Metering.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'rp.devices',
      //   },
      // },
      {
        path:      'b/tariffs/archive',
        name:      'uc_b_tariffs_archive_index',
        component: () => import('@/views/uc/b/TariffsArchiveIndex'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.tariffs',
        },
      },
      {
        path:      'b/tariffs/archive/:apartmentsType',
        name:      'uc_b_tariffs_archive',
        component: () => import('@/views/uc/b/TariffsArchive.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.tariffs',
        },
      },
      {
        path:      'b/tariffs',
        name:      'uc_b_tariffs_index',
        component: () => import('@/views/uc/b/TariffsIndex.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.tariffs',
        },
      },
      {
        path:      'b/tariffs/:apartmentsType',
        name:      'uc_b_tariffs',
        component: () => import('@/views/uc/b/Tariffs.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.tariffs',
        },
      },
      {
        path:      'b/invoices',
        name:      'uc_b_invoices',
        component: () => import('@/views/uc/b/Invoices.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.kv',
        },
      },
      {
        path:      'b/invoice',
        name:      'uc_b_invoice',
        component: () => import('@/views/uc/b/Invoice.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.kv',
        },
      },
      {
        path:      'b/accruals',
        name:      'uc_b_accruals',
        component: () => import('@/views/uc/b/Accruals.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.charges',
        },
      },
      {
        path:      'b/recalculations',
        name:      'uc_b_recalculations',
        component: () => import('@/views/uc/b/Recalculations.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.recalculation',
        },
      },
      {
        path:      'b/recalculations/add',
        name:      'uc_b_recalculations_add',
        component: () => import('@/views/uc/b/RecalculationsAdd.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.charges',
        },
      },
      {
        path:      'b/recalculation/:id',
        name:      'uc_b_recalculation',
        component: () => import('@/views/uc/b/Recalculation.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.charges',
        },
      },
      {
        path:      'b/payments',
        name:      'uc_b_payments',
        component: () => import('@/views/uc/b/Payments.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.invoices',
        },
      },
      {
        path:      'b/payments/add',
        name:      'uc_b_payments_add',
        component: () => import('@/views/uc/b/PaymentsAdd.vue'),
        meta:      {
          rule:          'isEmployee',
          abilities:     'rp.invoices',
          abilitiesRule: 'write',
        },
      },
      {
        path:      'b/payments/:id',
        name:      'uc_b_payment',
        component: () => import('@/views/uc/b/Payment.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.invoices',
        },
      },
      {
        path:      'b/refunds',
        name:      'uc_b_refunds',
        component: () => import('@/views/uc/b/Refunds.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.refunds',
        },
      },
      {
        path:      'b/refunds/add',
        name:      'uc_b_refunds_add',
        component: () => import('@/views/uc/b/RefundsAdd.vue'),
        meta:      {
          rule:          'isEmployee',
          abilities:     'rp.refunds',
          abilitiesRule: 'write',
        },
      },
      {
        path:      'b/reports',
        name:      'uc_b_reports',
        component: () => import('@/views/uc/b/Reports.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.reports',
        },
      },
      {
        path:      'b/import',
        name:      'uc_b_import',
        component: () => import('@/views/uc/b/Import.vue'),
        meta:      {
          rule:          'isEmployee',
          abilities:     ["rp.devices", "rp.apartments_import", "rp.invoices"],
          abilitiesRule: 'write',
        },
      },
      {
        path:      'b/regulations',
        name:      'uc_b_regulations',
        component: () => import('@/views/uc/b/Regulations.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.tariffs',
        },
      },
      {
        path:      'b/unresolved-payments',
        name:      'uc_b_unresolved_payments',
        component: () => import('@/views/uc/b/UnresolvedPayments.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.invoices',
        },
      },
      {
        path:      'b/settings',
        name:      'uc_b_settings',
        component: () => import('@/views/uc/b/Settings.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.settings',
          pageTitle: 'Настройки дома',
        },
      },
      {
        path:      'b/emails',
        name:      'uc_b_emails',
        component: () => import('@/views/uc/b/Emails.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.emails',
        },
      },
      {
        path:      'b/emails-history/:id',
        name:      'uc_b_emails_history',
        component: () => import('@/views/uc/b/EmailsHistory.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.emails',
        },
      },
      // {
      //   path:      'issues',
      //   name:      'uc_issues--old',
      //   component: () => import('@/views/uc/Issues--old.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      // {
      //   path:      'issues/new/view/:type',
      //   name:      'uc_issues',
      //   component: () => import('@/views/uc/Issues.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      // {
      //   path:      'issues/new/user/:user/:type',
      //   name:      'uc_issues_by_user',
      //   component: () => import('@/views/uc/Issues.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      // {
      //   path:      'issues/new/commercial/view/:type',
      //   name:      'uc_issues_commercial',
      //   component: () => import('@/views/uc/Issues.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      {
        path:      'issues',
        name:      'uc_issues',
        component: () => import('@/views/uc/Issues.vue'),
        meta:      {
          // showHeader: false,
          rule:      'isEmployee',
          abilities: 'issues',
        },
      },
      // {
      //   path:      'issues/new',
      //   name:      'uc_issues_new',
      //   component: () => import('@/views/uc/Issues.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      // {
      //   path:      'issues/assigned',
      //   name:      'uc_issues_assigned',
      //   component: () => import('@/views/uc/Issues.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      // {
      //   path:      'issues/progress',
      //   name:      'uc_issues_progress',
      //   component: () => import('@/views/uc/Issues.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      // {
      //   path:      'issues/closed',
      //   name:      'uc_issues_closed',
      //   component: () => import('@/views/uc/Issues.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      {
        path:      'issues/create',
        name:      'uc_issues_create',
        component: () => import('@/views/uc/IssueCreate.vue'),
        meta:      {
          // showHeader: false,
          rule:      'isEmployee',
          abilities: 'issues',
        },
      },
      {
        path:      'issues/:id',
        name:      'uc_issue',
        component: () => import('@/views/uc/Issue.vue'),
        meta:      {
          // showHeader: false,
          rule:      'isEmployee',
          abilities: 'issues',
        },
      },
      {
        path:      'issues/analytics/:type',
        name:      'uc_issues_analytics',
        component: () => import('@/views/uc/IssuesAnalytics.vue'),
        meta:      {
          // showHeader: false,
          rule: 'isEmployee',
          // abilities: 'issues',
          abilities: 'issues',
        },
      },
      // {
      //   path:      'houses',
      //   name:      'uc_houses',
      //   component: () => import('@/views/uc/Houses.vue'),
      //   meta:      {
      //     rule: 'isEmployee',
      //   },
      // },
      {
        path:      'news',
        name:      'uc_news',
        component: () => import('@/views/uc/news/News.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'pr.news',
        },
      },
      // {
      //   path:      'posters',
      //   name:      'uc_posters',
      //   component: () => import('@/views/uc/news/Posters.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'pr.posters',
      //   },
      // },
      {
        path:      'check-metering',
        name:      'uc_check_metering',
        component: () => import('@/views/uc/CheckMetering.vue'),
        meta:      {
          rule: 'isEmployee',
        },
      },
      {
        path:      'b/add-devices-values',
        name:      'uc_b_add_devices_values',
        component: () => import('@/views/uc/b/AddDevicesValues.vue'),
        meta:      {
          rule:          'isEmployee',
          abilities:     'rp.devices',
          abilitiesRule: 'write',
        },
      },
      {
        path:      'b/gis',
        name:      'uc_b_gis',
        component: () => import('@/views/uc/b/GIS.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.gis',
        },
      },
      {
        path:      'add-devices-values',
        name:      'uc_add_devices_values',
        component: () => import('@/views/uc/AddDevicesValues.vue'),
        meta:      {
          rule:          'isEmployee',
          abilities:     'rp.worker.add_values',
          abilitiesRule: 'write',
        },
      },
      // {
      //   path:      'tasks',
      //   name:      'uc_tasks',
      //   component: () => import('@/views/uc/Tasks.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      // {
      //   path:      'tasks-report',
      //   name:      'uc_tasks_report',
      //   component: () => import('@/views/uc/TasksReport.vue'),
      //   meta:      {
      //     rule:      'isEmployee',
      //     abilities: 'issues',
      //   },
      // },
      {
        path:      'b/financial-analytics',
        name:      'uc_b_financial_analytics',
        component: () => import('@/views/uc/b/FinancialAnalytics.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.fin_analysis',
        },
      },
      {
        path:      'b/financial-analytics/account/:id',
        name:      'uc_b_financial_analytics_account',
        component: () => import('@/views/uc/b/FinancialAnalyticsAccount.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.fin_analysis',
        },
      },
      {
        path:      'b/financial-analytics/account/:id/:month',
        name:      'uc_b_financial_analytics_account_month',
        component: () => import('@/views/uc/b/FinancialAnalyticsAccountMonth.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.fin_analysis',
        },
      },
      {
        path:      'b/acts',
        name:      'uc_b_acts',
        component: () => import('@/views/uc/b/Acts.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.acts',
        },
      },
      {
        path:      'reference-information',
        name:      'uc_b_reference_information',
        component: () => import('@/views/uc/ReferenceInformation.vue'),
        meta:      {
          rule: 'isEmployee',
        },
      },
      // {
      //   path:      'change-blog',
      //   name:      'changeBlog',
      //   component: () => import('@/views/uc/ChangeBlog.vue'),
      //   meta:      {
      //     rule: 'isEmployee',
      //   },
      // },
      {
        path:      'debtors/sms',
        name:      'uc_debtors_sms',
        component: () => import('@/views/uc/debtors/SendSms.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'debtors.sms',
        },
      },
      {
        path:      'debtors/email',
        name:      'uc_debtors_email',
        component: () => import('@/views/uc/debtors/SendEmail.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'debtors.email',
        },
      },
      {
        path:      'consistency-reports',
        name:      'uc_consistency_reports',
        component: () => import('@/views/uc/ConsistencyReports.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.main',
        },
      },
      {
        path:      'b/privileges',
        name:      'uc_b_privileges',
        component: () => import('@/views/uc/b/Privileges.vue'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.charges',
          // mcsIds:    [13],
        },
      },
      {
        path:      'b/gcjs',
        name:      'uc_b_gcjs',
        component: () => import('@/views/uc/b/GCJS'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.charges',
          // mcsIds:    [13],
        },
      },
      {
        path:      'b/apartments-groups',
        name:      'uc_b_apartments_groups',
        component: () => import('@/views/uc/b/ApartmentsGroups'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.main',
        },
      },

      {
        path:      'b/fines-recalculations',
        name:      'uc_b_fines_recalculations',
        component: () => import('@/views/uc/b/FinesRecalculations'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.recalculation',
        },
      },
      {
        path:      'b/fines-recalculations/add',
        name:      'uc_b_fines_recalculations_add',
        component: () => import('@/views/uc/b/FinesRecalculationsAdd'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.recalculation',
        },
      },
      {
        path:      'b/fines-recalculations/:id',
        name:      'uc_b_fines_recalculations_edit',
        component: () => import('@/views/uc/b/FinesRecalculationsAdd'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'rp.recalculation',
        },
      },
      {
        path:      'notifies',
        name:      'uc_notifies',
        component: () => import('@/views/uc/Notifies'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'debtors.notify',
        },
      },
      {
        path:      'notifies/config',
        name:      'uc_notifies_config',
        component: () => import('@/views/uc/NotifiesConfig'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'debtors.notify',
        },
      },
      {
        path:      'notifies/create',
        name:      'uc_notifies_create',
        component: () => import('@/views/uc/NotifiesCreate'),
        meta:      {
          rule:      'isEmployee',
          abilities: 'debtors.notify',
        },
      },

      {
        path:      'not-found',
        name:      'pageObjectNotFound',
        component: () => import('@/views/pages/ObjectNotFound.vue'),
        meta:      {
          rule: 'isEmployee',
        },
      },
      {
        path:      'forbidden',
        name:      'pageForbidden',
        component: () => import('@/views/pages/Forbidden.vue'),
        meta:      {
          rule: 'isEmployee',
        },
      },
    ],
  },
  // {
  //   path:      '/uc',
  //   component: () => import('@/layouts/employe-news-preview/NewsPreview.vue'),
  //   meta:      {
  //     access: USER_TYPE_EMPLOYEE,
  //   },
  //   children:  [
  //     {
  //       path:      'news/preview',
  //       name:      'uc_news_preview',
  //       component: () => import('@/views/uc/news/Preview.vue'),
  //       meta:      {
  //         pageTitle: 'Главная',
  //         rule:      'isEmployee',
  //       },
  //     },
  //     {
  //       path:      'news/preview/:id',
  //       name:      'preview_news',
  //       component: () => import('@/views/client/News.vue'),
  //       meta:      {
  //         pageTitle: 'Новости',
  //         rule:      'isEmployee',
  //       },
  //     },
  //   ],
  // },
];

export default routes;
